"use strict";import{Popover as e}from"./src/Popover.js";import{defineElement as o}from"@spectrum-web-components/base/src/define-element.js";o("sp-popover",e);
//# sourceMappingURL=sp-popover.js.map
